module.exports = __webpack_public_path__ + "build/img/code_hard.c8ab27aa.png";